import React, { useEffect, useState, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';

import { createDynamicTheme } from '@/themes';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useUI } from '@/hooks';
interface DynamicThemeWrapperProps {
    children: ReactNode;
}

const DynamicThemeWrapper: React.FC<DynamicThemeWrapperProps> = ({ children }) => {
    const { i18n } = useTranslation();
    const { theme } = useUI();

    const [currentTheme, setCurrentTheme] = useState(() => createDynamicTheme(i18n.language));

    useEffect(() => {
        setCurrentTheme(createDynamicTheme(i18n.language, theme));
    }, [theme, i18n.language]);

    useEffect(() => {
        const handleLanguageChange = (lng: string) => {
            setCurrentTheme(createDynamicTheme(lng));
        };

        // Listen for language changes
        i18n.on('languageChanged', handleLanguageChange);

        // Initial setup in case language was already set
        if (i18n.language) {
            handleLanguageChange(i18n.language);
        }

        return () => {
            i18n.off('languageChanged', handleLanguageChange);
        };
    }, []);

    return (
        <ThemeProvider theme={currentTheme}>
            <>
                <CssBaseline />
                {children}
            </>
        </ThemeProvider>
    );
};

export default DynamicThemeWrapper;
